import React, { useState, useContext, useEffect } from "react";
import { showInfoToast } from "../../validation/ToastContainer";
import { getConfirmPopup } from "../../view/popup/PopupContainer";
import { PopupContext } from "../../index"
import { modifyLogsScheduler, getLogsSelectedDaysPeriod } from "./logsRetentionService";


export default function LogsRetentionSection() {

  const [days, setDaysPeriod] = useState('0');
  const { setPopup } = useContext(PopupContext);



  // const setPeriod = false;
  const isStartDisabled = false;
  // const [selectedDate, setSelectedDate] = useState(new Date());

  const fetchData = async () => {
    try {
      let x = await getLogsSelectedDaysPeriod();
      setDaysPeriod(x);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSetLogsRetentionPeriodClick = event => {
    showInfoToast('Setting Logs Retention Period', 'Logs Retention Period');
    // setPeriod(true);

    setPopup(
      getConfirmPopup('Are you sure?',
        'Octopus VAR Logs Retention Period',
        () => onConfirm()
      )
    );

    const onConfirm = async () => {
      modifyLogsScheduler(days);
    };
  };

  const changeDaysPeriod = (value) => { setDaysPeriod(value); }

  return (
    <>
      <p className="oct_settings-description">
        App Logs Data logged before the Selected Days Period will be wiped permanently.
      </p>

      <div className="oct_settings-form-grid">
        <div className="oct_settings-field">
          <label className="oct_settings-label">Auto Logs Deletion Period</label>
          <input
            className="oct_settings-input-v2"
            type="number"
            value={days}
            onChange={event => changeDaysPeriod(event.target.value)}
          />
        </div>
        <div className="oct_settings-field">
          <label className="oct_settings-label">Unit</label>
          <select className="oct_select-v2" disabled>
            <option value="Days">Days</option>
          </select>
        </div>
      </div>

      <button
        className={`oct_settings-btn-v2 ${isStartDisabled ? 'disabled' : ''}`}
        onClick={onSetLogsRetentionPeriodClick}
      >
        Save App Logs Retention Period
      </button>
    </>
  );
}
